import { render, staticRenderFns } from "./VideoAutoplay.vue?vue&type=template&id=538f8df2"
import script from "./VideoAutoplay.vue?vue&type=script&lang=js"
export * from "./VideoAutoplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports